// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__iqFyD","topBottomGutter":"Layout_topBottomGutter__U9RC9"};